import { useForm } from 'react-hook-form';

import { ContentCard } from 'apps/dashboard/shared/scripts/components';
import { Group, Input } from 'apps/shared/scripts/components';
import {
  useCollapsibleForm,
  useYupValidation,
} from 'apps/shared/scripts/hooks';

import CollapsibleSettingsInput from '../CollapsibleSettingsInput';

import { DEFAULT_VALUES, FORM_FIELDS } from './constants';
import { labelClassName } from './styles';
import { FormValues } from './types';
import { schema } from './validation';

export interface Props {
  defaultValues?: FormValues;
  onSubmit: (data: FormValues) => Promise<void>;
  isSubmitting: boolean;
}

const SecuritySettingsForm = ({
  defaultValues = DEFAULT_VALUES,
  onSubmit,
  isSubmitting,
}: Props) => {
  const {
    control,
    formState: { dirtyFields, errors },
    handleSubmit,
    reset,
  } = useForm<FormValues>({
    defaultValues,
    resolver: useYupValidation<FormValues>(schema),
  });
  const collapsible = useCollapsibleForm({
    control,
    dirtyFields,
    errors,
    onSave: onSubmit,
    handleSubmit,
    isSaving: isSubmitting,
    reset,
  });

  return (
    <ContentCard>
      <form>
        <CollapsibleSettingsInput
          {...collapsible}
          label={'Password'}
          name={FORM_FIELDS.CONFIRM_PASSWORD.name}
          hidden
        >
          <Group
            labelClassName={labelClassName}
            label={FORM_FIELDS.CURRENT_PASSWORD.label}
            spacing
          >
            <Input
              control={control}
              name={FORM_FIELDS.CURRENT_PASSWORD.name}
              type="password"
            />
          </Group>
          <Group
            labelClassName={labelClassName}
            label={FORM_FIELDS.NEW_PASSWORD.label}
            spacing
          >
            <Input
              control={control}
              name={FORM_FIELDS.NEW_PASSWORD.name}
              type="password"
            />
          </Group>
          <Group
            labelClassName={labelClassName}
            label={FORM_FIELDS.CONFIRM_PASSWORD.label}
            spacing
          >
            <Input
              control={control}
              name={FORM_FIELDS.CONFIRM_PASSWORD.name}
              type="password"
            />
          </Group>
        </CollapsibleSettingsInput>
      </form>
    </ContentCard>
  );
};

SecuritySettingsForm.displayName = 'SecuritySettingsForm';

export default SecuritySettingsForm;
